import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import AkButton, { ButtonGroup } from '@atlaskit/button';
import { PrimaryCTA } from '@atlassian/amkt-common';
import React, { Component } from 'react';

var ConfirmCancelFooter = /*#__PURE__*/function (_Component) {
  _inherits(ConfirmCancelFooter, _Component);

  var _super = _createSuper(ConfirmCancelFooter);

  function ConfirmCancelFooter() {
    var _this;

    _classCallCheck(this, ConfirmCancelFooter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      return /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(PrimaryCTA, {
        testId: _this.props.testId,
        href: _this.props.href,
        isDisabled: _this.props.isPrimaryDisabled,
        onClick: _this.props.onPrimaryCTAClick,
        isLoading: _this.props.isLoading
      }, _this.props.primaryCTALabel), /*#__PURE__*/React.createElement(AkButton, {
        appearance: "subtle-link",
        onClick: _this.props.onClose
      }, "Cancel"));
    });

    return _this;
  }

  return ConfirmCancelFooter;
}(Component);

export { ConfirmCancelFooter as default };